import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MonitorSmartphone } from 'lucide-react';
import { Dialog } from '@/shared/ui/Dialog';
import { Button } from '@/shared/ui/Button';
import { useHubEvent } from '@/shared/realtime/useHubEvent';
import { useAuthStore } from '@/entities/session/model/authStore';
import { splitClientInfo } from '@/entities/session/lib/clientInfoText';

/** Aynı hesapla başka yerden giriş → DAL SystemHub `SessionExpired` → kapatılamaz modal. */
export function SessionExpiredDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  /*
   * Bildirim, oturumu düşüren YENİ girişin cihaz bilgisini taşıyor. "Başka bir yerden
   * giriş yapıldı" cümlesinin ardından sorulan ilk şey "nereden?" oluyordu; cihazı
   * söylemek, kullanıcının kendi ikinci tarayıcısı mı yoksa başkası mı olduğunu
   * ayırt etmesinin tek pratik yolu. Eski sunucu bilgiyi göndermiyorsa mesaj
   * eski hâlinde kalır.
   */
  const [device, setDevice] = useState<string | null>(null);
  const setLastLogoutDevice = useAuthStore((s) => s.setLastLogoutDevice);
  useHubEvent(
    'SessionExpired',
    useCallback(
      (byClientInfo?: string) => {
        setDevice(byClientInfo ?? null);
        // Giriş ekranı da aynı bilgiyi göstersin: pencere kapanınca oraya düşülüyor.
        setLastLogoutDevice(byClientInfo ?? null);
        setOpen(true);
      },
      [setLastLogoutDevice],
    ),
  );
  const logout = useAuthStore((s) => s.logout);
  const info = device ? splitClientInfo(device) : null;

  return (
    <Dialog
      open={open}
      onOpenChange={() => {}}
      dismissable={false}
      size="sm"
      title={t('auth.sessionExpired.title')}
      footer={
        <Button
          onClick={() => {
            setOpen(false);
            void logout('session-closed');
          }}
        >
          {t('auth.sessionExpired.action')}
        </Button>
      }
    >
      <p className="text-fg-muted text-sm">{t('auth.sessionExpired.body')}</p>
      {info ? (
        <div className="border-border bg-bg-muted mt-3 flex items-start gap-2 rounded-md border px-3 py-2 text-sm">
          <MonitorSmartphone className="text-fg-subtle mt-0.5 h-4 w-4 shrink-0" />
          <div className="min-w-0">
            <div className="text-fg-subtle text-[11px] tracking-wide uppercase">
              {t('auth.sessionExpired.fromDevice')}
            </div>
            <div className="break-words">{info.device}</div>
            {info.ip ? <div className="text-fg-muted text-xs">IP: {info.ip}</div> : null}
          </div>
        </div>
      ) : null}
    </Dialog>
  );
}
